import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/** Absolutní URL k souboru z API.

    Backend běží na jiné adrese než frontend (`REACT_APP_BACKEND_URL`), takže
    relativní `/api/files/...` z odpovědi vede na frontend a obrázek se
    nenačte. `<img>` ani nová záložka neprojdou přes axios, proto se prefix
    musí doplnit ručně. */
export function souborUrl(u) {
  if (!u) return null;
  if (/^https?:\/\//i.test(u)) return u;
  return `${process.env.REACT_APP_BACKEND_URL || ""}${u}`;
}

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    // /auth/me se obnovuje taky: po otevření aplikace je krátký přístupový
    // token dávno pryč a bez obnovy by se člověk musel pokaždé přihlásit znovu.
    const isAuthCall =
      url.includes("/auth/login") ||
      url.includes("/auth/refresh") ||
      url.includes("/auth/kod");

    if (error.response?.status === 401 && !original._retry && !isAuthCall) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/api/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(detail) {
  if (detail == null) return "Něco se nepovedlo, zkus to prosím znovu.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
